import { render, staticRenderFns } from "./HowPandemicAffected.vue?vue&type=template&id=26753dd6&"
import script from "./HowPandemicAffected.vue?vue&type=script&lang=js&"
export * from "./HowPandemicAffected.vue?vue&type=script&lang=js&"
import style0 from "./HowPandemicAffected.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports